module.exports = ".form-group {\n    position: relative;\n}\n\ni.fa.fa-eye,\ni.fa.fa-eye-slash {\n    position: absolute;\n    right: 5px;\n    bottom: 14px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cpassword/cpassword.component.css
// module id = ./src/app/components/cpassword/cpassword.component.css
// module chunks = main